module.exports = __webpack_public_path__ + "static/img/wjCode2.c3a8dda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xyd/index/wjCode2.png
// module id = xPgh
// module chunks = 81